import store from "@/store";
import NotifyService from "@/services/notify.service";
import { layout } from "@/configs/ourApp.config";

export default async (to, from, next) => {
  const authPages = [
    "Login",
    "AdminLogin",
    "ForgotPassword",
    "AdminForgotPassword",
    "Registration",
    "PrivacyPolicy",
  ];
  const publicPages = ["UserAgreement"];
  const isAuthPage = authPages.includes(to.name);
  const isPublicPage = publicPages.includes(to.name);
  const authTokenInQuery = to.query?.auth;
  const { isAuthenticatedUser } = store.getters;
  const { user } = store.state.user;
  const { isProduction, redirectLink } = layout.adminMono;

  if (authTokenInQuery) {
    await store.dispatch("loginByToken", authTokenInQuery);
  }

  NotifyService.getDelayed();

  if (isAuthPage) {
    if (isProduction) {
      if (isAuthenticatedUser) {
        return next({ name: "MainLayout" });
      }

      if (!authTokenInQuery) {
        window.location.href = redirectLink;

        return;
      }
    } else if (isAuthenticatedUser) {
      return next({ name: "MainLayout" });
    }
  } else if (isPublicPage) {
    if (isAuthenticatedUser) {
      await store.dispatch("verifyAuth");
      await store.dispatch("verifyImpersonateAuth");

      if (!user) {
        await store.dispatch("user/getProfile");
      }
    }
  } else {
    await store.dispatch("verifyAuth");
    await store.dispatch("verifyImpersonateAuth");

    if (isAuthenticatedUser && !user) {
      await store.dispatch("user/getProfile");
    }
  }

  const requiredPermission = to.matched
    .slice()
    .reverse()
    .find((route) => route.meta?.permission)?.meta?.permission;

  if (requiredPermission && !store.getters["user/getPermission"]?.[requiredPermission]) {
    return next({ name: "NotFound" });
  }

  next();
};
